////////LIBRARY/////////
import React, { useRef, useState, useEffect } from 'react'
import styled from 'styled-components'
import { map, isUndefined, isString, reduce, isEqual } from 'lodash'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { bindActionCreators } from 'redux'
import { useForm } from 'react-hook-form'
///////COMPONENTS///////
import ColumnsFilter from '../ColumnsFilter'
import {
	ActionWrapperElem,
	SearchInputWrapper,
	SearchInputButton,
	SearchReset,
	InputLogin,
	PageWrapperActionPrevPage,
	OptionCustom,
	SelectInputCustom,
	SelectInputWrapper,
} from '../../../../theme/GlobalCss'
import Tooltip from '../../../Tooltip/Tooltip'
import UseColumnsManager from '../../hooks/UseColumnsManager'
import Paging from '../Paging'
import ImgButton from '../../../Ui/ImgButton'
import Button from '../../../../components/Ui/Buttons'
import { columnsActionCreators, consignationActionsCreators, salesHistoryManagerActionCreators } from '../../../../store/actions'

/////////STYLED/////////
const WrapperHeader = styled.div`
	display: grid;
	grid-template-columns: ${(props) =>
		props.filtersBlocWidth > 0 ? `400px ${props.filtersBlocWidth}px 180px` : `repeat(2, minmax(min-content, max-content))`};
	grid-auto-flow: column;
	grid-column-gap: 10px;
	grid-template-rows: max-content;
	grid-auto-rows: 32px;
	justify-content: space-between;
	align-items: center;
	width: 100%;
`
const WrapperElement = styled.div`
	display: inline-flex;
	flex-flow: row-reverse wrap;
	-webkit-box-align: stretch;
	align-items: stretch;
	place-content: stretch;
	flex-basis: max-content;
`
const TableName = styled.div`
	display: inline-flex;
	justify-content: left;
	align-items: center;
	color: ${(props) => props.theme.colors.primary};
	font-weight: bold;
`
const FreeSearchWrapper = styled.div`
	position: relative;
	& > * > input {
		font-size: ${(props) => props.theme.font.fs};
	}
	display: flex;
	flex-direction: row;
`
const SplitX = styled.div`
	height: 32px;
	border-left: 1px solid ${(props) => props.theme.colors.dropdownDefault};
	width: 1px;
	box-sizing: border-box;
	margin: 8px 17px;
`
const InputLoginSearchBar = styled(InputLogin)`
	&::placeholder {
		color: ${(props) => props.theme.colors.menu.link};
	}
`
const Separator = styled.div`
	width: ${(props) => `${props.width}px`};
`
/////////STYLED/////////

const TableTitle = ({ inputConfig, inputColumns, isSortColumns, isFollowingStep, tableReferential }) => {
	const { translations, isEditingTrigger, formButtonWidth, isSingleEdit, implantationStoredDatas } = useSelector(
		(state) => ({
			translations: state.languages.translations,
			isEditingTrigger: state.columns.isEditingTrigger,
			isValidateEnable: state.columns.isValidateEnable,
			formButtonWidth: state.columns.formButtonWidth,
			isSingleEdit: state.columns.isSingleEdit,
			implantationStoredDatas: state.initKioskCreation.initKioskImplantation.storedDatas,
		}),
		shallowEqual
	)
	const [columns, handleColumnsFilter] = UseColumnsManager(
		inputColumns,
		() => {}, // this hook is sign with 3 arg to prevent error we need to set empty fn, ref: GLPI (2023020007)
		tableReferential
	)

	const [storedChecks, setStoredChecks] = useState([]) // Used for storing checked boxes
	const [selectTarget, setSelectTarget] = useState(false) // when is true we change placeholder color of select element
	const [filtersBlocWidth, setFiltersBlocWidth] = useState(0) // used to change grid wrapper size if we have to display 3 forms buttons
	const { reset, formState, watch } = useForm({
		mode: 'onChange',
	})
	const { isDirty, touched, isValid, isSubmitting } = formState

	const searchRef = useRef()
	const selectAction = useRef()
	const wrapperFilterRef = useRef()
	const wrapperTitleRef = useRef()
	const wrapperHeaderRef = useRef()
	const actionsColumns = bindActionCreators(columnsActionCreators, useDispatch())
	const actionsConsignation = bindActionCreators(consignationActionsCreators, useDispatch())
	const actionsSalesHistoryManager = bindActionCreators(salesHistoryManagerActionCreators, useDispatch())

	///////////////////////////////// HANDLE ///////////////////////////////////////

	const handleGetSelected = (target) => {
		const scope = isString(target) ? target : ''
		const query = target
		inputConfig.actions.edit.getDataSelected(createSelectedDataList(), scope, query)
	}
	// when we select an action to open a modal, we force the capacity to select the same modal when we close it
	const handleChoiceTarget = () => {
		setSelectTarget(true)
	}
	const createSelectedDataList = () => {
		// Old method. getValues() will only contains lines in DOM, not in all data available (but not rendered)
		// Therefore it is conflicting with windowing system.
		//const data = getValues()
		// we need to test if we go stored datas from kioskImplantation or other component when yse mass edit to set the correct data
		let data = []
		if (!isEqual(implantationStoredDatas, [])) {
			data = implantationStoredDatas
		} else {
			data = storedChecks
		}

		return reduce(
			data,
			(result, value) => {
				if (value) {
					const parsedValue = JSON.parse(value)
					if (parsedValue.standardLine || isUndefined(parsedValue.standardLine)) {
						result.push(JSON.parse(value))
					}
				}
				return result
			},
			[]
		)
	}

	const handleResetSelect = (_e, reset = false) => {
		if (reset) {
			setSelectTarget(false)

			selectAction.current.value = ''
			return null
		}
		handleChoiceTarget()
	}

	// we need to reset some of 'id' to by pass searchValue === myPage.myRedirectState.id on severals page
	const handleReset = (ref) => {
		actionsConsignation.resetTransactionNumber()
		actionsSalesHistoryManager.resetTransactionNumberConsignation()
		actionsColumns.setIsSearchfieldUpdated(true)
		inputConfig.actions.searchBarComponent.handleReset(ref)
	}
	/////////////////////////////// USE EFFECT /////////////////////////////////////

	// in case of mass edit on recap stock
	useEffect(() => {
		if (isEditingTrigger && isUndefined(inputConfig.isKioskAddPrices)) {
			// we need to determine 3 sizes values. We pass 2 in hard (400 & 180 ) first one corresponding to title bloc, second corresponding 3 actions btn
			let sumElementSize = wrapperFilterRef.current?.clientWidth + 400 + 180
			let additionalWidth = wrapperHeaderRef.current?.clientWidth - sumElementSize
			if (!isUndefined(wrapperFilterRef.current)) {
				setFiltersBlocWidth(wrapperFilterRef.current?.clientWidth + additionalWidth)
			}
		} else if (!isEditingTrigger) {
			setFiltersBlocWidth(0)
		}
	}, [wrapperFilterRef.current, wrapperTitleRef.current, wrapperHeaderRef.current, isEditingTrigger])

	//we need to reset this state when we load table for apply default css on WrapperHeader component
	useEffect(() => {
		actionsColumns.setIsEditingNotTrigger(false)
	}, [])
	///////////////////////////////// RENDER ///////////////////////////////////////
	return (
		!isUndefined(inputConfig.name) && (
			<WrapperHeader filtersBlocWidth={filtersBlocWidth} ref={wrapperHeaderRef}>
				<ActionWrapperElem ref={wrapperTitleRef}>
					<TableName>{inputConfig?.name}</TableName>
				</ActionWrapperElem>
				<WrapperElement ref={wrapperFilterRef}>
					{inputConfig?.actions?.followingStep?.step && (
						<>
							<ActionWrapperElem>
								<Button
									id={inputConfig.actions.followingStep.id}
									type={inputConfig.actions.followingStep.type}
									imgLeftMgin={inputConfig.actions.followingStep.imgLeftMgin}
									imgMgin={inputConfig.actions.followingStep.imgMgin}
									position={inputConfig.actions.followingStep.position}
									img={inputConfig.actions.followingStep.img}
									margin={inputConfig.actions.followingStep.margin}
									bgColor={inputConfig.actions.followingStep.bgColor}
									height={inputConfig.actions.followingStep.height}
									width={inputConfig.actions.followingStep.width}
									text={inputConfig.actions.followingStep.text}
									actionHandler={inputConfig.actions.followingStep.actionHandler}
									disabled={inputConfig.actions.followingStep.disabled}
									noHash
								/>
							</ActionWrapperElem>
						</>
					)}

					{inputConfig?.actions?.actionsList?.step && (
						<>
							<SelectInputWrapper blueColor={true} heightAfter={68} alignItems={'center'}>
								<SelectInputCustom
									width={inputConfig?.actions?.actionsList?.width}
									defaultValues=""
									//selectTarget={selectTarget}
									onChange={(e) => handleGetSelected(e)}
									ref={selectAction}
									onClick={(e) => handleResetSelect(e, true)}
									disabled={!isSingleEdit}
								>
									<OptionCustom value="" hidden>
										{translations['common__text__actions']}
									</OptionCustom>
									{map(inputConfig?.actions?.actionsList?.list, (elem, id) => {
										return (
											<OptionCustom
												key={id}
												value={elem.query}
												target={true}
												onClick={(e) => handleGetSelected(e.target) /*inputConfig.actions.edit.getDataSelected*/}
											>
												{translations[elem.translationKey]}
											</OptionCustom>
										)
									})}
								</SelectInputCustom>
							</SelectInputWrapper>

							{/* <SplitX /> */}
						</>
					)}
					{inputConfig.isKioskAddPrices ? (
						<>
							<Separator width={formButtonWidth} />
						</>
					) : null}
					{inputConfig?.actions?.saveStep?.step && (
						<>
							<ActionWrapperElem>
								<ImgButton
									id={inputConfig?.actions?.followingStep?.saveStep?.id}
									type={inputConfig?.actions?.saveStep?.type}
									marginRight={inputConfig?.actions?.saveStep?.marginRight}
									img={inputConfig?.actions?.saveStep?.icon}
									hover={inputConfig?.actions?.saveStep?.hover}
									disabled={inputConfig?.actions?.saveStep?.disabled}
								/>
							</ActionWrapperElem>
							{/* <SplitX /> */}
						</>
					)}

					{isFollowingStep && formButtonWidth === 0 ? <SplitX /> : null}
					{
						// boolean to hide sort column filter

						!isUndefined(isSortColumns) ? null : (
							<ActionWrapperElem>
								{isUndefined(inputConfig?.isInNestedTable) && isUndefined(inputConfig?.fixedColumnSelection) && (
									<Tooltip
										tooltipId={'filterColumns'}
										translationsKey={'tooltip__admin__table_filter__columnFilter'}
										position="left"
									>
										<ColumnsFilter columns={columns} setColumns={handleColumnsFilter} />
									</Tooltip>
								)}
							</ActionWrapperElem>
						)
					}

					{!isUndefined(isSortColumns) && !isSortColumns ? null : (
						<ActionWrapperElem>
							{!isUndefined(inputConfig?.paging) && (
								<Paging
									totalRow={inputConfig?.paging?.totalElements}
									totalPage={inputConfig?.paging?.totalPages}
									fnSendTo={inputConfig?.paging?.fnSendTo}
								/>
							)}
						</ActionWrapperElem>
					)}
					{isUndefined(isSortColumns) ? <SplitX /> : null}

					{
						// Sorting lists ?
						inputConfig.actions?.sortLists &&
							map(inputConfig.actions.sortLists, (item, id) => <ActionWrapperElem key={id}>{item()}</ActionWrapperElem>)
					}
					{
						// Date picker lists
						inputConfig.actions?.dateLists &&
							map(inputConfig.actions.dateLists, (item, id) => <ActionWrapperElem key={id}>{item()}</ActionWrapperElem>)
					}

					{
						// Dropdown lists
						inputConfig.actions?.rest &&
							map(inputConfig.actions?.rest, (item, id) => <ActionWrapperElem key={id}>{item()}</ActionWrapperElem>)
					}

					{
						// Search bar
						inputConfig?.actions?.searchBarComponent && (
							<ActionWrapperElem>
								<FreeSearchWrapper>
									<SearchInputWrapper>
										<InputLoginSearchBar
											ref={searchRef}
											onKeyDown={(e) => inputConfig.actions.searchBarComponent.handleSearchEnter(e, e.target.value)}
											placeholder={translations['page__translationManagement__table_filter__search']}
											defaultValue={inputConfig.actions.searchBarComponent.defaultValue}
											onBlur={(_e) => inputConfig.actions.searchBarComponent.handleClickSearch(searchRef)}
										/>
										<SearchInputButton onClick={() => inputConfig.actions.searchBarComponent.handleClickSearch(searchRef)} />
									</SearchInputWrapper>
									{searchRef?.current?.value?.length > 0 && <SearchReset onClick={() => handleReset(searchRef)} />}
								</FreeSearchWrapper>
							</ActionWrapperElem>
						)
					}
					{
						// Toggle lists
						inputConfig.actions?.toggleLists &&
							map(inputConfig.actions.toggleLists, (item, id) => <ActionWrapperElem key={id}>{item()}</ActionWrapperElem>)
					}
				</WrapperElement>
				{inputConfig?.close && <PageWrapperActionPrevPage onClick={() => inputConfig.actions.handleCloseModal()} />}
			</WrapperHeader>
		)
	)
}

export default TableTitle
